import React, { useState, useEffect } from "react";
import { SvgIcon } from "@/components/SvgIcon/index";
import "./index.less";
import store from "@/stores/authTabStore";
import { observer } from "mobx-react-lite";
import ClientTabs from "@/stores/clientTabStore";
type Props = {
  keys?: number[];
};
const AuthTab = observer((props: Props) => {
  const { keys } = props;
  const [tabList, setTabList] = useState([
    {
      key: 1,
      value: "抖音",
      icon: <SvgIcon width={24} height={24} name="icon-douyin" />,
    },
    {
      key: 2,
      value: "快手",
      icon: <SvgIcon width={24} height={24} name="icon-kuaishou" />,
    },
    {
      key: 3,
      value: "视频号",
      icon: <SvgIcon width={24} height={24} name="icon-shipinhao" />,
    },
    {
      key: 4,
      value: "小红书",
      icon: <SvgIcon width={24} height={24} name="icon-xiaohongshu-2" />,
    },
    // {
    //   key: 5,
    //   value: "TikTok",
    //   icon: <SvgIcon width={24} height={24} name="icon-douyin" />,
    // },
    // {
    //   key: 6,
    //   value: "哔哩哔哩",
    //   icon: <SvgIcon width={24} height={24} name="icon-blibli" />,
    // },
    // {
    //   key: 7,
    //   value: "今日头条",
    //   icon: <SvgIcon width={20} height={20} name="icon-jinritoutiao" />,
    // },
    // {
    //   key: 8,
    //   value: "百家号",
    //   icon: <SvgIcon width={20} height={20} name="icon-baijiahao-nh" />,
    // },
  ]);

  useEffect(() => {
    if (keys) {
      console.log("keys", keys);

      const arr = [];
      keys.map((item) => {
        const target = tabList.find((i) => i.key === item);
        if (target) {
          arr.push(target);
        }
      });
      setTabList(arr);
      store.updatePlatform(keys[0]);
    }
  }, []);
  const onClick = (value: number) => {
    store.updatePlatform(value);
  };
  return (
    <div
      className="pages-accountauth-authtab"
      style={{ marginLeft: ClientTabs.isClient ? "0px" : "16px" }}
    >
      {tabList.map((item) => {
        return (
          <div
            className={`item ${item.key === store.platform ? "active" : ""}`}
            key={item.key}
            onClick={() => onClick(item.key)}
          >
            <div className="item-box">
              {item.icon}
              <span className="label">{item.value}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
});
export default AuthTab;
